import React from "react";
import { FaRegFilePdf } from "react-icons/fa";
import PageTitle from "../../../titles/page-title";
import YearTitle from "../../../titles/year-title";

function Activities() {
  return (
    <div className="content-container">
      <PageTitle title="Správy o činnosti"></PageTitle>
      <YearTitle year={2024}></YearTitle>
      <div>
        <a
          href={
            process.env.PUBLIC_URL +
            "/pdf/reports/activities/Sprava_o_cinnosti_2023.pdf"
          }
          target="_blank"
          rel="noreferrer"
        >
          <FaRegFilePdf /> Správa o činnosti za rok 2023
        </a>
      </div>
      <br />
      <YearTitle year={2023}></YearTitle>
      <div>
        <a
          href={
            process.env.PUBLIC_URL +
            "/pdf/reports/activities/Sprava_o_cinnosti_2022.pdf"
          }
          target="_blank"
          rel="noreferrer"
        >
          <FaRegFilePdf /> Správa o činnosti za rok 2022
        </a>
      </div>
      <br />
    </div>
  );
}

export default Activities;
